exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".yxt-form-item.is-error .biz-selector-content,.yxt-form-item.is-error .biz-selector-content:focus{border-color:#f5222d}\n", ""]);

